export const TOOLTIP_TEXT = 'Auto-recharge and/or manually bought credits'

export const DEFAULT_PERIOD_TEXT = 'last 30 days'

export const PERIOD_PRICE_LABELS: Record<string, string> = {
  monthly: DEFAULT_PERIOD_TEXT,
  quarterly: 'last 3 months',
  'semi-annual': 'last 6 months',
  yearly: 'last 12 months',
}
export const PERIOD_PRICE_SHORT_LABELS: Record<string, string> = {
  monthly: 'mo',
  quarterly: '3 mo',
  'semi-annual': '6 mo',
  yearly: 'year',
}
export const CUSTOM_PLAN_PRICE_DIVISOR = 100
export const ADDITIONAL_CREDIT_PRECISION = 10000
